export default "src/content/themes/association-wordpress-theme/img/9409b7e833f1c1a4a10511cb6f143399.svg";